import { Component } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
    template: `
        <kendo-dialog-titlebar class="mb-2 flex items-center gap-1 bg-background px-4 py-6  font-bold text-primary">
            {{ 'History' | translate }}
        </kendo-dialog-titlebar>
        <div class="flex flex-col gap-4 p-6">
            <div class="flex items-start gap-3">
                <ng-icon class="mt-0.5 text-gray-500" name="faSolidUserPlus" size="16px" />
                <div class="flex flex-col">
                    <span class="text-xs text-gray-500">{{ 'Created By' | translate }}:</span>
                    <span class="font-medium">{{ info?.createdBy }}</span>
                    <span class="text-sm text-gray-600">{{ info?.createdDate | datetime }}</span>
                </div>
            </div>
            <div class="flex items-start gap-3">
                <ng-icon class="mt-0.5 text-gray-500" name="faSolidPenToSquare" size="16px" />
                <div class="flex flex-col">
                    <span class="text-xs text-gray-500">{{ 'Last Modified By' | translate }}:</span>
                    <span class="font-medium">{{ info?.lastModifiedBy }}</span>
                    <span class="text-sm text-gray-600">{{ info?.lastModifiedDate | datetime }}</span>
                </div>
            </div>
        </div>
        <kendo-dialog-actions layout="end">
            <app-button variant="primary" (clicked)="dialog.close()">{{ 'Close' | translate }}</app-button>
        </kendo-dialog-actions>
    `
})
export class RecordInfoComponent extends DialogContentBase {
    info: {
        createdBy?: string;
        createdDate?: string | Date;
        lastModifiedBy?: string;
        lastModifiedDate?: string | Date;
    } = {};

    constructor(public override dialog: DialogRef) {
        super(dialog);
    }

    initialize(data: typeof this.info) {
        this.info = data;
    }
}
